<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="项目名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.projectName"
              placeholder="请输入项目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区：" class="input-with-col2">
            <AddreassSelect
              :isSearch="true"
              :warning="addressWarn"
              :showDetailAddress="showDetailAddress"
              :addressName="addressName"
              @change="setPojectAddress"
            ></AddreassSelect>
          </el-form-item>
          <el-form-item label="使用单位：">
            <el-select
              size="mini"
              v-model="form.propertyUnitId"
              filterable
              placeholder="请选择使用单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电销计划：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.planId"
              placeholder="请输入电销计划号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="年检时间：">
            <el-date-picker v-model="form.createTimeBetween" size="mini" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd" unlink-panels
              clearable></el-date-picker>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          v-if="hasRole['XSXMTJ']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
          >添加</el-button
        >
        <el-button
          v-if="hasRole['XSXMSCWXJH']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAddWXJH"
          >生成外呼计划</el-button
        >

        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['XSXMSC']"
          >删除</el-button
        >
        <el-button
          v-if="hasRole['XSXMDR']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleInput"
          >导入</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="importRecords"
          plain
           v-if="hasRole['XSXMDR']"
          >导入记录</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="creditCode"
            label="省市区街道"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.provinceName }}
              {{ scope.row.cityName }}
              {{ scope.row.districtName }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contactTelephone"
            label="联系电话"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="operatorName"
            label="跟踪人员"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="currentNode"
            label="跟踪阶段"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="annualInspectionDate"
            label="年检时间"
            width="180"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            width="160"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="200px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['XSXMBJ']"
                type="text"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['XSXMXQ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['XSXMXQ']"
                type="text"
                @click="handleDetail(scope.row)"
                >详情</el-button
              >
              <div class="btn-divide" v-if="hasRole['XSXMSC']"></div>
              <el-button
                size="mini"
                v-if="hasRole['XSXMSC']"
                type="text"
                @click="handleDeleteUnit(scope.row)"
                >删除</el-button
              >
              <div class="btn-divide" v-if="hasRole['XSXMFQ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['XSXMFQ']"
                type="text"
                @click="handleFQ(scope.row)"
                >{{ scope.row.status === 20 ? "启用" : "放弃" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-project
      v-if="addProjectVisible"
      @cancel="addProjectVisible = false"
      @confirm="handleAddProjectConfirm"
    ></add-project>
    <edit-project
      v-if="editProjectVisible"
      :editData="projectDetail"
      @cancel="editProjectVisible = false"
      @confirm="handleEditProjectConfirm"
    ></edit-project>
    <check-project
      v-if="checkProjectVisible"
      :editData="projectDetail"
      @cancel="checkProjectVisible = false"
    ></check-project>
    <check-department
      v-if="checkDepartment"
      :editData="projectDetail"
      @cancel="checkDepartment = false"
    ></check-department>
    <detail-project
      v-if="detailProjectVisible"
      :projectId="projectId"
      @cancel="detailProjectVisible = false"
      @confirm="handleDetailProjectConfirm"
    >
    </detail-project>
    <add-whjh
      v-if="whjhOpen"
      :ids="whjhProjectIds"
      @cancel="whjhOpen = false"
      @confirm="whjhOpen = false"
    ></add-whjh>
    <import-dialog
      @cancel="showImport = false"
      @uploadFinish="uploadFinish"
      v-if="showImport"
      :importFun="importFun"
      :downFun="downFun"
    />
    <records v-if="showRecord" @cancel="showRecord = false"></records>
  </div>
</template>

<script>
import {
  getProjectList,
  deleteProject,
  getUnitSimpleList,
  updateStatus,
  exportTemplate,
  importSaleProject,
} from "@/api/salesManagement/ProjectManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import AddProject from "./components/AddProject";
import AddWhjh from "./components/WHJH";
import EditProject from "./components/EditProject";
import CheckProject from "./components/CheckProject";
import CheckDepartment from "./components/CheckDepartment";
import DetailProject from "./components/DetailProoject";
import ImportDialog from "@/components/ImportDialog/ImportDialog";
import Records from "@/pages/ElevatorManagement/components/Records";
export default {
  name: "SalesManagementProjectManagement",
  components: {
    AddWhjh,
    AddProject,
    EditProject,
    CheckProject,
    CheckDepartment,
    AddreassSelect,
    DetailProject,
    ImportDialog,
    Records,
  },
  data() {
    return {
      form: {
        projectName: "",
        propertyUnitId: "",
        cityCode: "",
        districtCode: "",
        provinceCode: "",
        planId: "",
        createTimeBetween: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addProjectVisible: false,
      editProjectVisible: false,
      checkProjectVisible: false,
      checkDepartment: false,
      detailProjectVisible: false,
      projectDetail: {},
      addressWarn: false,
      addressName: "项目地址",
      showDetailAddress: false,
      unitList: [],
      projectId: null,
      whjhOpen: false,
      whjhProjectIds: [],
      showRecord:false,
      showImport:false,
      importFun: importSaleProject,
      downFun: exportTemplate,
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
    this.searchUnitList();
  },
  methods: {
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (this.form.createTimeBetween) {
        delete params.createTimeBetween
        params.annualInspectionDateStart = this.form.createTimeBetween[1]
        params.annualInspectionDateEnd = this.form.createTimeBetween[0]
      }
      const res = await getProjectList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteUnit(row) {
      const idList = [row.id];
      this.deleteProject(idList);
    },
    handleFQ(row) {
      this.$confirm("确定更改状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await updateStatus({
            projectId: row.id,
            status: row.status === 10 ? 20 : 10,
          });
          if (res.code === 200) {
            this.$message.success("更改成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCheck(row) {
      this.projectDetail = row;
      this.checkDepartment = true;
    },
    handleEdit(row) {
      this.projectDetail = row;
      this.editProjectVisible = true;
    },
    handleDetail(row) {
      this.projectId = row.id;
      this.detailProjectVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteProject(idList);
    },
    deleteProject(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteProject({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addProjectVisible = true;
    },
    handleAddWXJH() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要生成外呼计划的项目");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.whjhProjectIds = idList;
      this.whjhOpen = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddProjectConfirm() {
      this.addProjectVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditProjectConfirm() {
      this.editProjectVisible = false;
      this.getListData();
    },
    handleDetailProjectConfirm() {
      this.editProjectVisible = false;
      this.getListData();
    },
    uploadFinish() {
      this.showImport = false;
      this.handleSearchListData();
    },
    handleInput() {
      this.showImport = true;
    },
    importRecords() {
      this.showRecord = true;
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
      this.getListData();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/ProjectManagement.vue